import { SalesMonitorActions } from 'constants/ActionsTypesTs'
import {
	IGetSalesMonitorItemsResponse,
	IGetZonesResponse,
	ISelectSalesMonitorResponse,
	IValidateBarCodeMonitorResponse
} from 'models/SalesMonitor'

export interface ISalesMonitorState {
	listZones: IGetZonesResponse | null
	salesMonitorList: IGetSalesMonitorItemsResponse | null
	barCodeResponse: IValidateBarCodeMonitorResponse | null
	selectedSalesMonitorItems: ISelectSalesMonitorResponse | null
	salesMonitorError: any
}

const initialState = {
	listZones: null,
	salesMonitorList: null,
	barCodeResponse: null,
	selectedSalesMonitorItems: null,
	salesMonitorError: null
}

function rootReducer(state: ISalesMonitorState = initialState, action: any) {
	switch (action.type) {
		case SalesMonitorActions.GET_ZONES:
			return { ...state, listZones: null }
		case SalesMonitorActions.GET_ZONES_SUCCESS:
			return { ...state, listZones: action.payload }
		case SalesMonitorActions.GET_SALES_MONITOR_ITEMS:
			return { ...state, salesMonitorList: null }
		case SalesMonitorActions.GET_SALES_MONITOR_ITEMS_SUCCESS:
			return { ...state, salesMonitorList: action.payload }
		case SalesMonitorActions.VALIDATE_BAR_CODE_MONITOR:
			return { ...state, barCodeResponse: null, salesMonitorError: null }
		case SalesMonitorActions.VALIDATE_BAR_CODE_MONITOR_SUCCESS:
			return { ...state, barCodeResponse: action.payload }
		case SalesMonitorActions.VALIDATE_BAR_CODE_MONITOR_ERROR:
			return {
				...state,
				barcodeResponse: null,
				salesMonitorError: action.payload
			}
		case SalesMonitorActions.SELECT_SALES_MONITOR_ITEMS:
			return {
				...state,
				selectedSalesMonitorItems: null,
				salesMonitorError: null
			}
		case SalesMonitorActions.SELECT_SALES_MONITOR_ITEMS_SUCCESS:
			return { ...state, selectedSalesMonitorItems: action.payload }
		case SalesMonitorActions.SELECT_SALES_MONITOR_ITEMS_ERROR:
			return {
				...state,
				selectedSalesMonitorItems: null,
				salesMonitorError: action.payload
			}
		case SalesMonitorActions.CONFIRM_SALES_MONITOR_ERROR:
			return { ...state, salesMonitorError: action.payload }
		default:
			return state
	}
}

export default rootReducer
